var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 3.8467V6.00004C14.6668 7.79337 13.9468 8.51337 12.1535 8.51337H11.5868V6.92672C11.5868 5.13338 10.8668 4.41337 9.07348 4.41337H7.48682V3.8467C7.48682 2.05337 8.20682 1.33337 10.0002 1.33337H12.1535C13.9468 1.33337 14.6668 2.05337 14.6668 3.8467Z",
    stroke: "#CCD2E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 12.1534V10C1.3335 8.20669 2.0535 7.48669 3.84683 7.48669H4.4135V9.07334C4.4135 10.8667 5.1335 11.5867 6.92683 11.5867H8.5135V12.1534C8.5135 13.9467 7.7935 14.6667 6.00016 14.6667H3.84683C2.0535 14.6667 1.3335 13.9467 1.3335 12.1534Z",
    stroke: "#CCD2E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5867 6.91996V9.07328C11.5867 10.8666 10.8667 11.5866 9.07341 11.5866H6.92007C5.12674 11.5866 4.40674 10.8666 4.40674 9.07328V6.91996C4.40674 5.12663 5.12674 4.40662 6.92007 4.40662H9.07341C10.8734 4.41328 11.5867 5.12663 11.5867 6.91996Z",
    stroke: "#64D5D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.0df4223f874774d27fd0aa29def0d376.svg";
export { ForwardRef as ReactComponent };